/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import React from 'react';
import ReactDOM from 'react-dom';
import ReactSuperSelect from 'react-super-select';

import DayPicker from "react-day-picker";
import DayPickerInput from "react-day-picker/DayPickerInput";
import MomentLocaleUtils from 'react-day-picker/moment';


import uuid from 'node-uuid';
import {Button, Grid, Row, Col} from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import ReactSpinner from 'react-spinjs';
import Slider from 'react-rangeslider'
import moment from 'moment';

import UserStore from '../../stores/UserStore';
import APIActions from '../../actions/apiActions';
import JobStore from '../../stores/JobStore';
import JobDayHistoryTable from './jobDayHistoryTable';
import AppConstants from '../../constants/AppConstants';


const style = { width: 400, margin: 50 };

export default class JobHistorySelector extends React.Component {
    constructor(props) {
        super(props);

        this._onJobChange = this._onJobChange.bind(this);
        this.selectEvent = this.selectEvent.bind(this);
        this.selectHistoryDay = this.selectHistoryDay.bind(this);

        this.state = {
            historySummary : {ok: [], warn: [], error: []},
            historyKey : 1,
            locale : navigator.language
        }
    }

    componentDidMount() {
        console.log("[JobHistorySelector] - componentDidMount");
        JobStore.addChangeListener(this._onJobChange) ;
    }

    componentWillUnmount() {
        console.log("[JobHistorySelector] - componentWillUnmount");
        JobStore.removeChangeListener(this._onJobChange);
    }

    _onJobChange(payload) {
        if (!payload) {
            return ;
        }

        console.log("JOB EVENT: ", payload) ;
        var s = this.state ;
        switch (payload.event) {
            case AppConstants.GET_JOB_HISTORY_DAY:
                var hist = JobStore.historyForDay(this.state.loadingDay) ;
                if (hist) {
                    hist.forEach((v) => {
                        v.time = moment.utc(v.ts, 'YYYYMMDDHHmmss').local() ;
                        v.tsx = moment.utc(v.ts, 'YYYYMMDDHHmmss').local().format('YYYYMMDDHHmmss') ;
                    });

                    this.setState({dayhistory: hist, loadingDay: null, historyKey : this.state.historyKey + 1});
                }
                else {
                    this.setState({dayhistory: [], loadingDay: null, historyKey : this.state.historyKey + 1});
                }

                break ;
            default: break ;
        }
    }

    selectHistoryDay(day) {
        if (!day) {
            console.log("No history day specified");
            return ;
        }

        var target = moment(day).local().format('YYYYMMDD') ;
        console.log("Loading history for day: ", day, target);

        var hist = JobStore.historyForDay(target) ;
        if (!hist) {
            var targetdate = target + "000000";
            var nowt = moment(targetdate,'YYYYMMDDHHmmss');
            var off = nowt.utcOffset();
            var fromtime = moment(nowt).add(-off,'minutes');
            var totime = moment(fromtime).add(1,'days');

            APIActions.jobHistoryRange(this.props.job.jobId, fromtime.format('YYYYMMDDHHmmss'), totime.format('YYYYMMDDHHmmss'));
            this.setState({loadingDay: targetdate});
        }
        else {
            hist.forEach((v) => {
                v.time = moment.utc(v.ts, 'YYYYMMDDHHmmss').local() ;
                v.tsx = moment.utc(v.ts, 'YYYYMMDDHHmmss').local().format('YYYYMMDDHHmmss') ;
            });

            this.setState({dayhistory: hist, loadingDay: null, historyKey : this.state.historyKey + 1});
        }
    }

    selectEvent(eventTime) {
        // alert("SELECT HISTORY DAY:" + JSON.stringify(eventTime));
        let h = this.state.dayhistory.find((v) => {
            return v.ts === eventTime.ts;
        }) ;

        if (h) {
            this.props.historySelected(h,this.props.job.state.mode);
        }
    }

    render() {
        var isAdmin = UserStore.isAdministrator();
        var self = this ;

        var modifiers = {
            ok : this.props.historySummary.ok,
            warn : this.props.historySummary.warn,
            error : this.props.historySummary.error,
            mondays: { daysOfWeek: [1] },
            todayButton: 'TODAY',
          };

        console.log("HISTORY SELECTOR: ", modifiers) ;

        return (
            <div>

                {(this.props.historyDates.length > 0) &&
                    <Grid>
                        <Row>
                            <Col md={3}>
                                <b>Earliest History Available:</b><br/>{this.props.startDate}<br/>
                                <b>Latest History Available:</b><br/>{this.props.endDate}<br/><br/>
                                <p>
                                Select a date from the Calendar below - if there is data available for that date then it will be displayed in the table to the right. Selecting a row in this table will then display the data at that time point.
                                </p>
                                <br/>
                                <DayPicker
                                        localeUtils={MomentLocaleUtils}
                                        locale={this.state.locale}
                                        enableOutsideDays
                                        initialMonth={new Date()}
                                        fromMonth={this.state.minDate}
                                        toMonth={new Date()}
                                        modifiers={modifiers}
                                        onDayClick={(day) => {
                                            self.selectHistoryDay(day);
                                        }}
                                />
                            </Col>
                            <Col md={7}>
                                <JobDayHistoryTable key={this.state.historyKey} history={this.state.dayhistory || []} onSelect={this.selectEvent} />
                            </Col>
                        </Row>
                    </Grid>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/jobs/jobHistorySelector.js